import { render, staticRenderFns } from "./ShowcasesContentSlider.vue?vue&type=template&id=80f843f8&"
import script from "./ShowcasesContentSlider.vue?vue&type=script&lang=js&"
export * from "./ShowcasesContentSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports